import { Login } from "@mui/icons-material";
import { Chip, Typography } from "@mui/material";
import { authentication } from "e.sic-platform.webclient/src/services/authentication/Authentication";
import { translationService } from "e.sic-platform.webclient/src/services/translation/TranslationService";
import { observer } from "mobx-react-lite";
import { useCallback } from "react";
import { useLocation } from "react-router-dom";

export default observer(function LoginButton() {
    const location = useLocation();

    // Return to the page the user is on (e.g. home). loginToAccess also overwrites any stale
    // post-login route left by an earlier, abandoned app-card login, which otherwise would
    // send the user to that app after signing in.
    const login = useCallback(() => {
        authentication.loginToAccess(location.pathname + location.search);
    }, [location.pathname, location.search])

    return (
        <Chip
            sx={{mr: 1}}
            deleteIcon={<Login fontSize="large" />}
            onDelete={login}
            color="primary"
            onClick={login}
            variant="outlined"
            label={<Typography variant="body1">{translationService.translate("general.login")}</Typography>}
        />
    )
})
